import APIError from "./APIError";

class PGRESTResult {
  data?: any;
  error?: APIError;
  headers?: { [key: string]: string };
}

export default PGRESTResult;
